const daysBetween = (date1, date2) => {
  const oneDay = 1000 * 60 * 60 * 24;
  const date1Ms = new Date(date1).getTime();
  const date2Ms = new Date(date2).getTime();
  const differenceMs = date2Ms - date1Ms;
  return parseInt(Math.round(differenceMs / oneDay), 10);
};

export default daysBetween;
